import { style, media } from 'typestyle'
import { important } from 'csx'
export const pr12mdi = style(media({ maxWidth: 768 }, { paddingRight: important('12px') }))
